import AppController from './controllers/AppController';
import Logger from './utils/Logger';


new Logger();
new AppController();
